export interface FilterSectionHeaderProps {
  title: string;
}

export function FilterSectionHeader({ title }: FilterSectionHeaderProps) {
  return (
    <span className="tw-text-xs tw-font-semibold tw-text-muted-foreground tw-uppercase tw-tracking-wide">
      {title}
    </span>
  );
}
